export const spaceId = 'dopephonk';
export const artworkSize = 400;